import type { NotificationsOptions } from '@kyvg/vue3-notification'
import { notify } from '@kyvg/vue3-notification'

import { emitter } from '@kidzonet/inject-bus-emit'

export const useShowNotificationBannerAndAnnounceMessage = (
    notifyOptions: NotificationsOptions,
    message: string,
    timeout?: number,
) => {
    notify(notifyOptions)
    emitter.emit('pronounce', { message, timeout })
}
